module.exports = __webpack_public_path__ + "static/media/17UN-Women7.34e33586.jpg";